import { tabKey, type TabContext } from "../session/tab-context";

// Le chiavi delle letture dei WhatsApp nelle Impostazioni (piano M6, R1, Task 5a), in un modulo senza altre dipendenze: le usano
// `settings-api.ts` e le scritture del Team (`api/queries.ts`), che dopo una sospensione, un'archiviazione o un ruolo cambiato
// rileggono il WhatsApp delle persone (chi c'è, chi è sospeso, a chi si può impostare).

export const whatsAppSettingsKeys = {
  senders: (tab: TabContext) => ["scheda", tabKey(tab), "whatsapp", "senders"] as const,
  channels: (tab: TabContext) => ["scheda", tabKey(tab), "whatsapp", "channels"] as const,
};
